//Generated File 
export default class FieldSubType{
	static readonly Json = `Json`;
	static readonly SqlQuery = `SqlQuery`;
	static readonly TempoTemplate = `TempoTemplate`;
	static readonly Xml = `Xml`;
}
